import React from "react";

function ImagePopup({ image, onClose }) {
  return (
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose} // Close on backdrop click
    >
      <div
        className="bg-white rounded-lg p-4 relative"
        onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside
      >
        {/* Close Button */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Image */}
        <div className="flex justify-center items-center">
          <img
            src={image}
            alt="Preview"
            className="w-40 h-40 rounded-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}

export default ImagePopup;
